import { useEffect, useState } from 'react';
import '../CookieConsentModal/style.scss';
import { ClientSideStorageService } from '../../services/client-side-storage.service';
import { SanitizerService } from '../../services/sanitizer.service';
import FocusTrap from '../Shared/FocusTrap';
import { IServerSideRendered } from '../Shared/Base/server-side-rendered';
import { useTexts } from '../../hooks/texts.hook';

export interface IQuickCookieConsentModalTexts {
  quickcookieconsenttext: string;
}

export type IQuickCookieConsentModalSettings = object;

type IQuickCookieConsentModalProps = IServerSideRendered<IQuickCookieConsentModalTexts, IQuickCookieConsentModalSettings>;

function QuickCookieConsentModal({ texts }: IQuickCookieConsentModalProps) {
  // === HOOKS ===
  const { t } = useTexts();

  // === STATE ===
  const [show, setShow] = useState(false);

  useEffect(() => {
    function handleShowEvent() {
      setShow(true);
    }

    document.addEventListener('show-quick-cookie-consent-modal', handleShowEvent);

    return () => {
      document.removeEventListener('show-quick-cookie-consent-modal', handleShowEvent);
    };
  }, []);

  function handleApproveAllClick() {
    const success = ClientSideStorageService.approveAll();
    setShow(!success);

    if (success) {
      document.dispatchEvent(new CustomEvent('consent-status-approved'));
    }
  }

  return (
    <>
      {show && (
        <FocusTrap isVisible={show} onEscape={() => setShow(false)}>
          <div className="modal d-block fade show" aria-labelledby="quick-cookie-consent-modal-title" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header pb-0">
                  <div id="quick-cookie-consent-modal-title" dangerouslySetInnerHTML={{ __html: SanitizerService.sanitizeHtml(texts.quickcookieconsenttext) }}></div>
                </div>

                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary flex-fill cookie-consent-modal__btn" onClick={() => setShow(false)}>
                    {t.cancel}
                  </button>
                  <button type="button" className="btn btn-primary flex-fill cookie-consent-modal__btn" onClick={handleApproveAllClick}>
                    {t('Godkänn', 'Approve')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </FocusTrap>
      )}
      {show && <div className="modal-backdrop fade show"></div>}
    </>
  );
}

export default QuickCookieConsentModal;
